<ng-container *ngIf="tickersOptions && tickersOptions.length">
  <div class="ticker-container">
    <atr-single-ticker [isMobile]="isMobile" [tickerDirection]="tickerDirection" [ticker]="displayedTicker" [tickerClass]="tickerTypeClass" [showButtons]="tickersOptions.length > 1"
                       [tickerTranslation]="tickerTypeTranslation" (closeTicker)="onCloseTicker($event)" (changeTicker)="changeTicker($event)" [canChange]="canChange" [isSinglePreview]="isSinglePreview" ></atr-single-ticker>
  </div>
</ng-container>
